export const UNVERIFIED_ASSET_MARKDOWN_FONT_SIZE = 14;
